import type { ReactElement } from "react";
import type { RouteObject } from "react-router-dom";

import { OPERATIONAL_MODULE_SLUGS } from "@shared/api/server/gs3Server";
import {
  OperationalModuleEntryPage,
  OperationalModuleStructurePage,
} from "@shared/components";
import { GeneralStructurePage } from "@modules/general";
import { InspectionStructurePage } from "@modules/inspection";
import {
  operationalModuleLoader,
  operationalStructureLoader,
} from "../loaders/operationalLoaders";

// Rotas dos módulos operacionais (fatia 3). Para CADA módulo canônico: rota
// /<slug> protegida pelo loader operacional (gate de deep link), com um índice
// (seletor de estrutura) e um filho /:structureId guardado pelo loader de
// estrutura. Fonte única dos slugs: OPERATIONAL_MODULE_SLUGS (camada de API).
// Fonte de produto: docs/prd/operational-modules/operational-modules.md
// §3.3.2 / §3.3.3; quality-test §0.3.2.
// Módulos já implementados têm página própria em `/<slug>/:structureId`; os
// demais caem no placeholder compartilhado.
const MODULE_STRUCTURE_PAGES: Record<string, ReactElement> = {
  General: <GeneralStructurePage />,
  Inspection: <InspectionStructurePage />,
};

export const buildOperationalModuleRoutes = (): RouteObject[] =>
  Object.entries(OPERATIONAL_MODULE_SLUGS).map(
    ([moduleKey, slug]) =>
      ({
        path: slug,
        loader: operationalModuleLoader(moduleKey),
        children: [
          {
            index: true,
            element: <OperationalModuleEntryPage />,
          },
          {
            path: ":structureId",
            loader: operationalStructureLoader(moduleKey),
            element: MODULE_STRUCTURE_PAGES[moduleKey] ?? (
              <OperationalModuleStructurePage moduleKey={moduleKey} />
            ),
          },
        ],
      }) satisfies RouteObject,
  );
